import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';

export type RequestAccountDeletionResponse = {
  requestedAt: string;
  alreadyRequested: boolean;
};

export function requestAccountDeletionErrorMessage(err: unknown): string {
  if (err && typeof err === 'object' && 'message' in err) {
    const message = String((err as { message: string }).message);
    if (message && !message.startsWith('Firebase')) {
      return message;
    }
  }
  if (err && typeof err === 'object' && 'code' in err) {
    const code = String((err as { code: string }).code);
    if (code === 'functions/unauthenticated') {
      return 'Sign in to delete your account.';
    }
    if (code === 'functions/unavailable') {
      return 'Account service is temporarily unavailable. Try again.';
    }
    if (code === 'functions/internal' || code === 'functions/deadline-exceeded') {
      return 'Could not delete your account. Try again or contact support.';
    }
  }
  return err instanceof Error ? err.message : 'Could not delete your account.';
}

export async function requestAccountDeletion(): Promise<RequestAccountDeletionResponse> {
  const fn = httpsCallable<void, RequestAccountDeletionResponse>(functions, 'requestAccountDeletion');
  const result = await fn();
  const requestedAt =
    typeof result.data.requestedAt === 'string' && result.data.requestedAt.trim()
      ? result.data.requestedAt
      : new Date().toISOString();
  return {
    requestedAt,
    alreadyRequested: result.data.alreadyRequested === true,
  };
}
